import React, { SVGProps } from 'react'

const hotFireIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.25 3C14.2281 5.21022 13.75 11.4375 13.75 11.4375C13.75 11.4375 15.5 10.875 15.5 8.34376C17.5879 9.51118 19 11.7551 19 14.25C19 17.9779 15.866 21 12 21C8.134 21 5 17.9779 5 14.25C5.00004 8.76563 10.25 7.64062 10.25 3Z'
      fill='url(#paint0_linear_1850_24008)'
    />
    <defs>
      <linearGradient id='paint0_linear_1850_24008' x1='12' y1='3' x2='12' y2='21' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FECF88' />
        <stop offset='1' stopColor='#F7931A' />
      </linearGradient>
    </defs>
  </svg>
)

interface NewFireIconProps {
  red: boolean
  props?: SVGProps<SVGSVGElement>
}

const NewFireIcon = (props: NewFireIconProps) => {
  return (
    <>
      {props.red ? (
        hotFireIcon(props.props)
      ) : (
        <svg {...props} viewBox='0 0 24 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <g filter='url(#filter0_d_1714_50333)'>
            <path
              d='M10.25 3C14.2281 5.21022 13.75 11.4375 13.75 11.4375C13.75 11.4375 15.5 10.875 15.5 8.34376C17.5879 9.51118 19 11.7551 19 14.25C19 17.9779 15.866 21 12 21C8.134 21 5 17.9779 5 14.25C5.00004 8.76563 10.25 7.64062 10.25 3Z'
              fill='url(#paint0_linear_1714_50333)'
            />
          </g>
          <defs>
            <filter
              id='filter0_d_1714_50333'
              x='1'
              y='3'
              width='22'
              height='26'
              filterUnits='userSpaceOnUse'
              colorInterpolationFilters='sRGB'>
              <feFlood floodOpacity='0' result='BackgroundImageFix' />
              <feColorMatrix
                in='SourceAlpha'
                type='matrix'
                values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                result='hardAlpha'
              />
              <feOffset dy='4' />
              <feGaussianBlur stdDeviation='2' />
              <feComposite in2='hardAlpha' operator='out' />
              <feColorMatrix type='matrix' values='0 0 0 0 0.419608 0 0 0 0 0.615686 0 0 0 0 1 0 0 0 0.25 0' />
              <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1714_50333' />
              <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1714_50333' result='shape' />
            </filter>
            <linearGradient id='paint0_linear_1714_50333' x1='12' y1='3' x2='12' y2='21' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#B0CCFF' />
              <stop offset='1' stopColor='#6B9DFF' />
            </linearGradient>
          </defs>
        </svg>
      )}
    </>
  )
}

export default NewFireIcon
